import { reviewsSummaryQuery } from "~/gql/reviews.gql"

export const useReviewsStore = defineStore('reviews', {
  state: () => ({
    aggregated: {},
    localCount: null,
    globalCount: null
  }),

  actions: {
    async GET_SUMMARY () {
      const { $sentry } = useNuxtApp()

      try {
        const response = await useDatoQuery({
          query: reviewsSummaryQuery,
          variables: {
            country: 'GB'
          },
          prefetchedRequest: 'reviewSummary',
        })

        this.aggregated = response.data.value.aggregated
        this.localCount = response.data.value.local.count
        this.globalCount = response.data.value.global.count
      } catch(error) {
        $sentry.captureException(error)
        console.error(error)
      }
    }
  }
})
